import * as React from "react";
import { Icon } from "../Icon/icon";
import { DelayedRender } from "../DelayedRender/DelayedRender";
export interface InputErrorProps {
  errorText?: string;
  delayRender?: number;
  id: string;
}

const DEFAULT_DELAY: number = 250;

/**
 * Renders the input error of a field with a delay.
 */
export function InputError(props: InputErrorProps) {
  const delayRender =
    typeof props.delayRender === "undefined"
      ? DEFAULT_DELAY
      : props.delayRender;
  return (
    props.errorText && (
      <DelayedRender delay={delayRender}>
        <React.Fragment>
          <span className="error-message" role="alert">
            <Icon
              iconType="Summering_inte_OK25px25px"
              className="form-summary__not-valid"
            />
            <span id={props.id}>{props.errorText}</span>
          </span>
        </React.Fragment>
      </DelayedRender>
    )
  );
}
